 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-te~b107aec6":"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-te~b107aec6","announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462":"announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462","announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54":"announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54","about~login~main-template~services-details":"about~login~main-template~services-details","login":"login","about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d":"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d","about":"about","main-template":"main-template","services-details":"services-details","announcement":"announcement","announcement-details":"announcement-details","announcement-home":"announcement-home","forgot-password":"forgot-password","home":"home","my-profile":"my-profile","order-details":"order-details","order-home":"order-home","register":"register","reset-password":"reset-password","services":"services","status":"status","contact":"contact","messenger-account-deletion":"messenger-account-deletion","messenger-privacy":"messenger-privacy","messenger-legal-preview":"messenger-legal-preview"}[chunkId]||chunkId) + "." + {"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-te~b107aec6":"4b6d5050","announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462":"39fdeffd","announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54":"966e4aa9","about~login~main-template~services-details":"ab0aab2d","login":"3448acbc","about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d":"8c8572f3","about":"44587dad","main-template":"c9991f31","services-details":"85227c4e","announcement":"70528387","announcement-details":"3dbfc495","announcement-home":"6bd60003","forgot-password":"216c1b5a","home":"16580a8e","my-profile":"fbcb4a87","order-details":"ab804e31","order-home":"3ccea45d","register":"aa1cef31","reset-password":"8e195583","services":"e65e11b5","status":"fa6a3c3e","contact":"ad81708a","messenger-account-deletion":"9fedb3f5","messenger-privacy":"ab6f0d7f","messenger-legal-preview":"4cf98fe9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462":1,"announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54":1,"about~login~main-template~services-details":1,"login":1,"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d":1,"about":1,"main-template":1,"services-details":1,"announcement":1,"announcement-details":1,"announcement-home":1,"forgot-password":1,"home":1,"my-profile":1,"order-details":1,"order-home":1,"register":1,"reset-password":1,"services":1,"status":1,"contact":1,"messenger-account-deletion":1,"messenger-privacy":1,"messenger-legal-preview":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-te~b107aec6":"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-te~b107aec6","announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462":"announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462","announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54":"announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54","about~login~main-template~services-details":"about~login~main-template~services-details","login":"login","about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d":"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d","about":"about","main-template":"main-template","services-details":"services-details","announcement":"announcement","announcement-details":"announcement-details","announcement-home":"announcement-home","forgot-password":"forgot-password","home":"home","my-profile":"my-profile","order-details":"order-details","order-home":"order-home","register":"register","reset-password":"reset-password","services":"services","status":"status","contact":"contact","messenger-account-deletion":"messenger-account-deletion","messenger-privacy":"messenger-privacy","messenger-legal-preview":"messenger-legal-preview"}[chunkId]||chunkId) + "." + {"about~announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-te~b107aec6":"31d6cfe0","announcement~announcement-details~announcement-home~contact~forgot-password~home~login~main-template~f6106462":"bf89eba1","announcement~announcement-details~announcement-home~forgot-password~home~login~my-profile~order-deta~3a3dad54":"f5aa0fee","about~login~main-template~services-details":"eb3234db","login":"c283978d","about~announcement~announcement-details~announcement-home~contact~forgot-password~home~main-template~6680e92d":"fb55a2c0","about":"d4280344","main-template":"713aad1e","services-details":"0e62ea84","announcement":"32685b73","announcement-details":"c475aa60","announcement-home":"97b72f3a","forgot-password":"c1e454d3","home":"c40d1082","my-profile":"07dbdabe","order-details":"c7698a5a","order-home":"bdb09398","register":"9e29880c","reset-password":"5aa67796","services":"d644d721","status":"e5b1ff94","contact":"1539e9dc","messenger-account-deletion":"254feed7","messenger-privacy":"56216a4d","messenger-legal-preview":"6a409522"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
